module.exports = {
  title: "t2",

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,

  baseApi: process.env.VUE_APP_BASE_API || "",
};
